import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";

export default class Role extends BaseInstitutionEntity{
    name: string;
    readThirdPartyAccounts: boolean = false;
    manageThirdPartyAccounts: boolean = false;
    manageThirdPartyPaymentOrders: boolean = true;
    readInstitutionalAccounts: boolean = false;
    manageInstitutionalAccounts: boolean = false;
    manageInstitutionalPaymentOrders: boolean = true;
    readCustomerAccounts: boolean = false;
    manageCustomerAccounts: boolean = false;
    manageCustomerPaymentOrders: boolean = false;
    readLendingAccounts: boolean = false;
    manageLendingAccounts: boolean = false;
    readProducts: boolean = false;
    manageProducts: boolean = false;
    readRateSources: boolean = false;
    manageRateSources: boolean = false;
    readAccounting: boolean = false;
    manageAccounting: boolean = false;
    readReports: boolean = false;
    manageReports: boolean = false;
    readUsers: boolean = false;
    manageUsers: boolean = false;
    readRoles: boolean = false;
    manageRoles: boolean = false;
    readInstitutionSettings: boolean = false;
    manageInstitutionSettings: boolean = false;
    readAppMediums: boolean = false;
    manageAppMediums: boolean = false;
    readWebhooks: boolean = false;
    manageWebhooks: boolean = false;
}